<div [formGroup]="raccordementForm">
  <div class="container">
    <div class="card">
      <div class="card-body">
        <h2 class="card-title">Raccordement</h2>

        <div class="row mb-3">
          <label for="puissanceCentraleEstimee" class="form-label">Puissance estimative de la centrale</label>
          <div class="col-11">
            <input id="puissanceCentraleEstimee" class="form-control" formControlName="puissanceCentraleEstimee" readonly>
          </div>
          <div class="col-1">
            <span class="spanTextMiddle">kWc</span>
          </div>
        </div>

        <div class="mb-3">
          <button
            type="button"
            class="btn btn-outline-primary"
            (click)="calculatePuissanceTotaleKwc()"
            [disabled]="isCalculatingPower">
            Calculer la puissance totale kwc
          </button>
        </div>

        <div *ngIf="powerCalculationErrorMessage" class="alert alert-danger" role="alert">
          {{ powerCalculationErrorMessage }}
        </div>

        <div class="mb-3">
          <div class="form-label">Raccordement haute tension ou basse tension ?</div>
          <div class="raccordement-type-row" role="group">
            <div class="btn-group d-flex w-100">
              <input type="radio" class="btn-check" name="typeRaccordement" id="typeRaccordementBt" [checked]="selectedRaccordementType === 'BT'" (change)="selectRaccordementType('BT')">
              <label class="btn btn-outline-success w-50" for="typeRaccordementBt">BT</label>
              <input type="radio" class="btn-check" name="typeRaccordement" id="typeRaccordementHt" [checked]="selectedRaccordementType === 'HT'" (change)="selectRaccordementType('HT')">
              <label class="btn btn-outline-success w-50" for="typeRaccordementHt">HT</label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <h2 class="card-title">Compteurs et Tranchées</h2>

        <div *ngIf="shouldShowBtCounterFields()" class="row mb-3 align-items-center">
          <div class="col-12 col-xl-4">
            <input id="nombreCompteur" type="number" class="form-control" formControlName="nombreCompteur" readonly>
          </div>
          <div class="col-12 col-xl-3">
            <span class="counter-suffix spanTextMiddle">compteurs</span>
          </div>
        </div>

        <div *ngIf="shouldShowCounterWarning()" class="alert alert-warning counter-warning" role="alert">
          {{ messageNombreCentraleBtMax }}
        </div>

        <div class="action-row">
          <button type="button" class="btn trench-action-btn" [ngClass]="isActionActive('private') ? 'btn-success' : 'btn-outline-success'" (click)="startPrivateTrench()">
            <i class="bi bi-plus-circle trench-action-icon"></i>
            <span>{{ getPrivateButtonLabel() }}</span>
          </button>
          <button
            *ngIf="isPublicTrenchAllowed()"
            type="button"
            class="btn trench-action-btn"
            [ngClass]="isActionActive('public') ? 'btn-primary' : 'btn-outline-primary'"
            (click)="startPublicTrench()">
            <i class="bi bi-plus-circle trench-action-icon"></i>
            <span>Ajouter une tranchée publique</span>
          </button>
        </div>

        <div *ngIf="isPrivateSelectionVisible()" class="zone-select mt-3">
          <div class="d-flex flex-wrap gap-2 mb-3">
            <button
              type="button"
              class="btn"
              [ngClass]="isActionActive('ptr') ? 'btn-success' : 'btn-outline-success'"
              (click)="togglePrivatePdlSelection()">
              PDL
            </button>
            <ng-container *ngFor="let zoneId of [1, 2, 3, 4, 5, 6]">
              <button
                *ngIf="canSelectPrivateZone(zoneId)"
                type="button"
                class="btn"
                [ngClass]="pendingZoneIds.includes(zoneId) ? 'btn-success' : 'btn-outline-success'"
                (click)="togglePrivateZoneSelection(zoneId)">
                Zone {{ zoneId }}
              </button>
            </ng-container>
          </div>
          <span class="form-label d-block">{{ getPendingZoneSelectionLabel() }}</span>
          <div class="mt-3">
            <button type="button" class="btn btn-success" (click)="confirmZoneSelection()">Valider</button>
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <h2 class="card-title">Tableau Des Tranchées</h2>
        <div class="table-responsive">
          <table class="table table-bordered align-middle mb-0">
            <thead>
              <tr>
                <th>Zone</th>
                <th>Enrobe</th>
                <th>Terrain naturel</th>
                <th>Passage toiture</th>
                <th class="icon-column"></th>
                <th class="icon-column"></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of trenchRows">
                <td>{{ row.zoneLabel }}</td>
                <td>
                  <div class="input-group trench-table-group">
                    <input class="form-control trench-table-input" type="number" step="0.01" [value]="row.enrobee || ''" (change)="editTrenchValue(row.zoneLabel, 'enrobee', $event)">
                    <span class="input-group-text">ml</span>
                  </div>
                </td>
                <td>
                  <div class="input-group trench-table-group">
                    <input class="form-control trench-table-input" type="number" step="0.01" [value]="row.terrainNaturel || ''" (change)="editTrenchValue(row.zoneLabel, 'terrainNaturel', $event)">
                    <span class="input-group-text">ml</span>
                  </div>
                </td>
                <td>
                  <div class="input-group trench-table-group">
                    <input class="form-control trench-table-input" type="number" step="0.01" [value]="row.passageToiture || ''" (change)="editTrenchValue(row.zoneLabel, 'passageToiture', $event)">
                    <span class="input-group-text">ml</span>
                  </div>
                </td>
                <td class="icon-column">
                  <button type="button" class="btn btn-sm btn-outline-primary icon-only-btn" (click)="editRow(row.zoneLabel)" title="Modifier">
                    <i class="bi bi-pencil"></i>
                  </button>
                </td>
                <td class="icon-column">
                  <button type="button" class="btn btn-sm btn-outline-danger icon-only-btn" (click)="deleteRow(row.zoneLabel)" title="Supprimer">
                    <i class="bi bi-trash"></i>
                  </button>
                </td>
              </tr>
              <tr *ngIf="trenchRows.length === 0">
                <td colspan="6" class="text-center">Aucune tranchée selectionnée</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
